
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
// @ts-ignore
import Puzzle from './Puzzle'

import { staticPath } from '@/utils/image'
import { Nullable } from '@/shared'

import CModal from '@/components/modal'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'

import addProtocol from '@/utils/addProtocol'

const DEBUG = process.env.NODE_ENV !== 'production'

const config = {
  name: 'v-Single-poi-content-puzzle',
  components: {
    ...CModal,
    CImage,
    CLoader,
    CButton,
    CButtonLabel,
    CButtonIcon
  }
}

@Component(config)
export default class VSinglePoiContentPuzzle extends Vue {

  @Prop({ type: Object, required: true }) content!: any

  puzzleModalIsOpen: boolean = false
  puzzleDepositIsOpen: boolean = false
  puzzleResultIsOpen: boolean = false

  timer: number = 0
  startingDelay: number = 3
  puzzle: Nullable<Puzzle> = null
  // @ts-ignore
  // startingInter: number = setInterval(() => {/**/}) as any
  startingInter: any
  // @ts-ignore
  // timerInter: number = setInterval(() => {/**/}) as any
  timerInter: any
  count: number = 0
  savedScrollStop: number = 0

  get image () {
    if (!this.content) return null
    return this.content.data.image
  }

  get imageId () {
    if (!this.content) return null
    return this.content.data.image.id
  }

  get title () {
    if (!this.content || !this.content.data.i18n.title) return null
    return this.content.data.i18n.title.value
  }

  get description () {
    if (!this.content || !this.content.data.i18n.description) return null
    const description = this.content.data.i18n.description.value
    if (description.text.length < 4) return null
    return description.html
  }

  get conclusion () {
    if (!this.content || !this.content.data.i18n.conclusion) return null
    const conclusion = this.content.data.i18n.conclusion.value
    if (conclusion.text.length < 1) return null
    return conclusion.html
  }

  @Watch('content')
  onContentUpdate () {
    this.destroyPuzzle()
    this.initPuzzle()
  }

  @Watch('puzzleModalIsOpen')
  onPuzzleModalStateChange () {
    const poiScrollContainer: Nullable<HTMLElement> = document.querySelector('.v-SinglePoi__Scrollable')
    if (this.puzzleModalIsOpen && poiScrollContainer) {
      this.savedScrollStop = poiScrollContainer.scrollTop
      poiScrollContainer.scrollTo(0, 0)
      poiScrollContainer.style.overflow = 'hidden'
      this.initPuzzle()
    } else if (!this.puzzleModalIsOpen && poiScrollContainer) {
      poiScrollContainer.style.overflow = ''
      poiScrollContainer.scrollTo(0, this.savedScrollStop)
      this.destroyPuzzle()
    }
  }

  initPuzzle () {
    this.timer = 0
    this.startingDelay = this.content.data.timer || 3
    this.$nextTick(() => {
      this.puzzle = new Puzzle(this.$refs.canvas, staticPath(addProtocol(this.content.data.image.file.url)), {
        xPieces: this.content.data.xPieces || 5,
        yPieces: this.content.data.yPieces || 6
      })
      this.puzzle.handleResize(true)
      this.puzzle.registerEndGameCallback((info: any) => {
        // this.completeGame({ correct: true })
        console.log('Puzzle is completed', info)
        this.puzzleResultIsOpen = true
        clearInterval(this.timerInter)
      })  
      this.puzzle.registerAfterMoveCallback((info: string) => {
        console.log('after move =>', info)
        this.count += 1
      })
      this.startingInter = setInterval(() => {
        if (DEBUG) console.log('[puzzle] starting inter')
        this.startingDelay -= 1
        if (this.startingDelay === 0) {
          clearInterval(this.startingInter)
          this.puzzle.start()
          this.timerInter = setInterval(() => {
            if (DEBUG) console.log('[puzzle] timer inter')
            this.timer += 1
          }, 1000)
        }
      }, 1000)
    })
  }

  destroyPuzzle () {
    clearInterval(this.startingInter)
    clearInterval(this.timerInter)
    this.count = 0
    // this.puzzle.handleResize(false)
  }

  onClickPuzzleCard () {
    if (this.description) return this.puzzleDepositIsOpen = true
    this.puzzleModalIsOpen = true
  }

  onClickPuzzlePlayButton () {
    this.puzzleDepositIsOpen = false
    this.puzzleModalIsOpen = true
  }

  onClosePuzzle () {
    console.log('on close puzzle')
    this.puzzleResultIsOpen = false
    this.puzzleModalIsOpen = false
  }

  onReloadPuzzle () {
    console.log('on reload puzzle')
    this.puzzleResultIsOpen = false
    this.destroyPuzzle()
    this.initPuzzle()
  }
}
